import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { SplashScreen } from 'src/components/loading-screen';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const router = useRouter();

  const { authenticated, loading } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (loading) {
      return;
    }
    if (!authenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      router.replace(`${paths.auth.login}?${searchParams}`);
    } else {
      setChecked(true);
    }
  }, [authenticated, loading, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (loading || !checked) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
